/** Position arrives about once a second; the fill must glide across that gap, not step. */
export const POSITION_TICK_SECS = 1;

export function progressFillPct(position: number, duration: number): number {
  if (!(duration > 0) || !Number.isFinite(position)) return 0;
  return Math.min(100, Math.max(0, (position / duration) * 100));
}

export function progressFillTransition(isScrubbing: boolean): string {
  return isScrubbing ? 'none' : `width ${POSITION_TICK_SECS}s linear`;
}
